var _title, _desc, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconMapPin = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  className: "icon icon--map-pin",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  ref: svgRef
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", {
  id: "icon--map-pin__title"
}, "Map Pin")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
  id: "icon--map-pin__description"
}, "Map pin")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 10,
  r: 3
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconMapPin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconMapPin.61b41170.svg";
export { ForwardRef as ReactComponent };